var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"frag",rawName:"v-frag"}],staticClass:"about"},[_c('h1',[_vm._v("This is an about page")])])
}
var staticRenderFns = []

export { render, staticRenderFns }